import { z } from 'zod';

import { InstanceIdType } from '#core/schema/defs';
import { CogniteDescribableModel } from '#core/schema/model/cdm/CogniteDescribableModel';
import { CogniteSchedulableModel } from '#core/schema/model/cdm/CogniteSchedulableModel';

export const ScaleDiscoveryModel = z
  .object({
    ...CogniteDescribableModel.shape,
    ...CogniteSchedulableModel.shape,

    depth: z.number().describe('Depth of the scale discovery.'),
    diameter: z.number().optional().describe('Diameter of the scale discovery.'),
    scaleComposition: z.string().optional().describe('Composition of the scale discovery.'),
    labAnalysis: z.record(z.string(), z.any()).optional().describe('Lab analysis of the scale discovery.'),
    wellstring: InstanceIdType.optional().describe('Well string of the scale discovery.'),
  })
  .describe('Scale discovery event in a well.');

export type ScaleDiscoveryModelInput = z.input<typeof ScaleDiscoveryModel>;
export type ScaleDiscoveryModelOutput = z.output<typeof ScaleDiscoveryModel>;
